import { render, staticRenderFns } from "./minimap2.vue?vue&type=template&id=5985d1d8&scoped=true&"
import script from "./minimap2.vue?vue&type=script&lang=js&"
export * from "./minimap2.vue?vue&type=script&lang=js&"
import style0 from "./minimap2.vue?vue&type=style&index=0&id=5985d1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985d1d8",
  null
  
)

export default component.exports